var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-provider',{ref:"modalProvider",staticClass:"pay-part-modal",attrs:{"name":"pay-part-modal","width":570,"title":_vm.$t('product-page__pay-part-modal-title')},on:{"before-open":_vm.disableScroll,"before-close":_vm.enableScroll}},[_c('div',{staticClass:"pay-part-modal"},[_c('pay-part-modal-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }